export default {
	evirPx_Severity: "Gravedad",
	evirPx_Date: "Fecha",
	evirPx_Time: "Hora",
	evirPx_Asset_Number: "Número del activo",
	evirPx_Asset_Type: "Tipo de activo",
	evirPx_Insp_Name: "Nombre de inspección",
	evirPx_Insp_Type: "Tipo de inspección",
	evirPx_Inspector: "Inspector",
	evirPx_Asset_Location: "Ubicación del activo",
	evirPx_No_Results_Found: "No se encontraron resultados",
	evirPx_User_Created_Asset: "Activo creado por usuario",
	evirPx_Incomplete_Inspection: "Inspección incompleta",
	evirPx_Additional_Asset_Information: "Más Información Sobre Recursos",
	evirPx_inspection_history: "Historial de inspección",
	evirPx_records: "registros",
	evirPx_record: "registro",
	evirPx_total: "total",
	evirPx_failed: "fallidas",
	evirPx_failed_inspections_detected: "Inspecciones Fallidas Detectadas",
	evirPx_unique_issues_bulk_fix: "problemas únicos se pueden solucionar en lote",
	evirPx_inspection: "inspección",
	evirPx_inspections: "inspecciones",
	evirPx_affected_by_issue: "afectadas por este problema",
	evirPx_fix_all: "Corregir Todos",
	evirPx_failed_inspection: "Inspección Fallida",
	evirPx_fix_inspection: "Corregir Inspección",
	evirPx_fix_inspection_description: "Revise y confirme la corrección sugerida para esta inspección fallida.",
	evirPx_issue: "Problema",
	evirPx_suggested_driver: "Conductor Sugerido",
	evirPx_high_confidence: "alta confianza",
	evirPx_is_this_correct: "¿Es correcto? Si no, por favor elija el conductor correcto:",
	evirPx_use_suggested: "Usar sugerido",
	evirPx_select_different_driver: "Seleccionar otro conductor...",
	evirPx_cancel: "Cancelar",
	evirPx_apply_fix: "Aplicar Corrección",
	evirPx_actions: "Acciones",
	evirPx_fix: "Corregir",
	evirPx_reload: "Recargar",
	evirPx_delete: "Eliminar",
	evirPx_delete_inspection_record: "¿Eliminar Registro de Inspección?",
	evirPx_action_cannot_be_undone: "Esta acción no se puede deshacer",
	evirPx_fmcsa_compliance_warning: "Advertencia de Cumplimiento FMCSA:",
	evirPx_delete_compliance_warning: "Eliminar inspecciones puede eliminar datos requeridos por FMCSA. Esto podría afectar su registro de cumplimiento y pista de auditoría.",
	evirPx_inspection_to_delete: "Inspección a eliminar:",
	evirPx_status: "Estado",
	evirPx_date_time: "Fecha/Hora",
	evirPx_driver_tag: "Etiqueta del Conductor",
	evirPx_asset_tag: "Etiqueta del Activo",
	evirPx_division: "División",
	evirPx_certify_delete: "Certifico que esta actualización es verdadera y reconozco que eliminar estos datos de inspección puede afectar los registros de cumplimiento.",
	evirPx_delete_inspection: "Eliminar Inspección",
	evirPx_failed_inspection_not_fixed: "La inspección fallida no ha sido corregida.",
	evirPx_Verification_Type: "Tipo de verificación",
	evirPx_Incomplete: "Incompleto",
	evirPx_Unverified: "No verificado",
	evirPx_Multiple: "Varios",
	evirPx_Search: "Buscar",
	evirPx_Clear_Selected: "Borrar selección",
	evirPx_Cancel: "Cancelar",
	evirPx_Apply: "Aplicar",
	evirPx_Major_Defects: "Desperfectos graves",
	evirPx_Minor_Defects: "Desperfectos leves",
	evirPx_No_Defects: "Ningún desperfecto",
	evirPx_Inspection_Name: "Nombre de la inspección",
	evirPx_Inspection_Type: "Tipo de inspección",
	evirPx_Date_Range: "Intervalo de fechas",
	evirPx_Date_Range_Today: "Hoy",
	evirPx_Date_Range_Previous_7: "7 días previos",
	evirPx_Date_Range_Previous_14: "14 días previos",
	evirPx_Date_Range_Previous_30: "30 días previos",
	evirPx_Date_Range_Previous_365: "365 días previos",
	evirPx_Date_Range_Custom: "Personalizado",
	evirPx_Assets: "Recursos",
	evirPx_Inspectors: "Inspectores",
	evirPx_Divisions: "Divisiones",
	evirPx_Tags: "Etiquetas",
	evirPx_Search_To_Filter: "Búsqueda por filtro",
	evirPx_export_selected_csv: "Exportar selección (CSV)",
	evirPx_export_all_csv: "Exportar todos (CSV)",
	evirPx_Clear_Filters: "Borrar Filtros",
	evirPx_Tag: "Etiqueta",
};
